import { HomeView } from "../screens/Home";

export default function AppStack(props: any) {
  return (
    <HomeView />
  );
}
